import {TireRim} from "../../../libs/enum/vehicle/tire-rim.enum";
import {isDefined} from "../../../libs/utils/epic.utils";
import {TireState} from "../../../libs/enum/vehicle/tire-state.enum";
import {TireSeason} from "../../../libs/enum/vehicle/tire-season.enum";

export class VehicleTireDto {

  public id!: string;
  public state!: TireState;
  // read-only / only for output
  public readonly stateChanged!: Date;
  // @Size(max = 255, message = "validation.maxlength")
  public manufacturer: string | undefined;
  // <width>: <205>/55 R16 91V / in mm
  // @Min(value = 1, message = "validation.min")
  public width: number | undefined;
  // <height>: 205/<55> R16 91V
  // @Min(value = 1, message = "validation.min")
  public height: number | undefined;
  // <identifier>: 205/55 <R>16 91V / Default: R
  // @Size(max = 10, message = "validation.maxlength")
  public identifier: string | undefined;
  // <diameter>: 205/55 R<16> 91V
  // @Min(value = 1, message = "validation.min")
  public diameter: number | undefined;
  // <loadIndex>: 205/55 R16 <91>V
  // @Min(value = 1, message = "validation.min")
  public loadIndex: number | undefined;
  // <speedIndex>: 205/55 R16 91<V>
  // @Size(max = 10, message = "validation.maxlength")
  public speedIndex: string | undefined;
  // Profile depth in mm
  // @Min(value = 0, message = "validation.min")
  public profileDepth: number | undefined;
  // Default: UNKNOWN
  public season!: TireSeason;
  // Felgen-Art / Default: UNKNOWN
  public rim!: TireRim;
  // Serienbereifung / Default: FALSE
  public series!: boolean;
  // Austauschen / Default: FALSE
  public replace!: boolean;
  // Schneeketten / Default: FALSE
  public snowChains!: boolean;
  // HTML
  public storageLocation: string | undefined;
  // HTML / Zubehör
  public accessories: string | undefined;
  // read-only / only for output
  public readonly vehicleId!: string;
  // read-only / only for output
  // 205/55 R16 91V // width, height, identifier, diameter, loadIndex, speedIndex
  public readonly identification!: string;

  constructor(init?: Partial<VehicleTireDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.stateChanged)) {
      this.stateChanged = new Date(init.stateChanged);
    }
  }

  public isEditable(): boolean {
    return true;
  }

  public clone(): VehicleTireDto {
    return new VehicleTireDto(this);
  }
}
